<template>
    <div class="wrap">
        <div class="container">
            <h3 class="personal_titile">添加地址</h3>
            <div class="adddz">
          <form @submit="saveAddress">
            <div class="address_input_item">
              <label>
                收货人
                <span>*</span>
              </label>
              <input
                type="text"
                maxlength="50"
                placeholder="请输入"
                v-model="full_name"
                required
              />
            </div>

            <div class="address_input_item">
              <label>
                手机号
                <span>*</span>
              </label>
              <input
                type="text"
                placeholder="请输入"
                v-model="tel"
                required
                pattern="^1[3-9]\d{9}$"
              />
            </div>

            <div class="address_input_item">
              <label>
                所在地区
                <span>*</span>
              </label>
              <input
                type="text"
                readonly
                placeholder="请输入"
                @click="showCountryPicker = true"
                v-model="address_info.country_name"
              />
              <van-popup v-model="showCountryPicker" position="bottom">
                <van-picker
                  show-toolbar
                  value-key="name"
                  :columns="countryPicker"
                  @cancel="showCountryPicker = false"
                  @confirm="changeCity($event, 'country')"
                />
              </van-popup>
            </div>

            <div class="address_input_item">
              <label>
                城市
                <span>*</span>
              </label>
              <input
                type="text"
                readonly
                placeholder="请输入"
                @click="showStatePicker = true"
                v-model="address_info.province_name"
              />
              <van-popup v-model="showStatePicker" position="bottom">
                <van-picker
                  show-toolbar
                  value-key="name"
                  :columns="statePicker"
                  @cancel="showStatePicker = false"
                  @confirm="changeCity($event, 'state')"
                />
              </van-popup>
            </div>

            <div class="address_input_item">
              <label>
                区县
                <span>*</span>
              </label>
              <input
                type="text"
                readonly
                placeholder="请输入"
                @click="showCityPicker = true"
                v-model="address_info.city_name"
              />
              <van-popup v-model="showCityPicker" position="bottom">
                <van-picker
                  show-toolbar
                  value-key="name"
                  :columns="cityPicker"
                  @cancel="showCityPicker = false"
                  @confirm="changeCity($event, 'city')"
                />
              </van-popup>
            </div>

            <div class="address_input_item">
              <label>
                详细地址
                <span>*</span>
              </label>
              <input 
                type="text" 
                placeholder="请输入"
                v-model="address_line" 
                required 
              />
            </div>
            
            <div class="save_btn_container">
              <button type="submit" class="save_address_btn">保存</button>
            </div>
          </form>
        </div>

        </div>
    </div>
</template>
<style scoped>
.address_info {
  background-color: #fff;
  height: 100%;
}

.adddz {
  padding: 15px;
}

.address_input_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

.address_input_item label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #14142B;
  margin-bottom: 8px;
}

.address_input_item label span {
  color: #EB5757;
}

.address_input_item input {
  width: 77%;
  height: 47px;
  border: 1px solid #9E9E9E;
  box-sizing: border-box;
  padding: 0 15px;
  font-size: 14px;
  color: #14142B;
}

.set_default_address {
  margin: 20px 0;
}

.save_btn_container {
  margin-top: 30px;
}

.save_address_btn {
  width: 100%;
  height: 47px;
  background-color: #14142B;
  color: white;
  border: none;
  font-size: 14px;
  font-weight: 600;
}
</style>
<script>
// import { areaList } from '@vant/area-data';
    export default {
        components: {},
        created() {
            this.id = this.$route.params.id;
            this.getData();
        },
        data() {
            return {
              // areaList,
                id: 0,
                address_info : {},
                countryPicker:[{id:0,name:'请选择'}],
                statePicker: [{id:0,name:'请选择'}],
                cityPicker:[{id:0,name:'请选择'}],
                showCountryPicker: false,
                showStatePicker: false,
                showCityPicker: false,
                country_key: 0,
                province_key: 0,
                city_key: 0,
                country:'',


                countryName: '请选择',
                stateName: '请选择',
                cityName: '请选择',
                country_id:0,
                province_id: 0,
                city_id: 0,
                email : '',
                full_name: '',
                postal_code: '',
                tel: '',
                address_line: '',
            }
        },
        methods: {
            getData(){
                var url = 'api/useraddress/Detail'
                var data = {id:0};
                var _self = this;

                this.POST(url,data,function (ret) {
                    if(ret.code === 0){
                        _self.countryPicker    = [{id:0,name:'请选择'}]
                        _self.countryPicker    = _self.countryPicker.concat(ret.data.country);
                        _self.statePicker   = [{id:0,name:'请选择-'}]
                        _self.statePicker   = _self.statePicker.concat(ret.data.province);
                        _self.cityPicker    = [{id:0,name:'请选择'}]
                        _self.cityPicker    = _self.cityPicker.concat(ret.data.city);
                        _self.country_key  = ret.data.country_key;
                        _self.province_key  = ret.data.province_key;
                        _self.city_key      = ret.data.city_key;                        
                        _self.address_info.country_name = '请选择';
                        _self.address_info.country_id = 0;                
                        _self.address_info.province_name = '请选择';
                        _self.address_info.province_id = 0;
                        _self.address_info.city_name = '请选择';
                        _self.address_info.city_id = 0
                    }
                })
            },
            changeCity(e,type){
                var _self = this;
                var url = '';
                var data = '';
                if(type === 'country'){
                    this.address_info.country_name = e.name;
                    this.address_info.country = e.id;
                    this.showCountryPicker = false;
                    if(e.id > 0) {
                        url = 'api/region/index';
                        data = {pid: e.id};
                        this.POST(url, data, function (ret) {
                            if (ret.code === 0) {
                                _self.province_key   = 0
                                _self.statePicker = [{id:0,name:'请选择'}]
                                _self.statePicker = _self.statePicker.concat(ret.data);
                                _self.city_key   = 0
                                _self.cityPicker = [{id:0,name:'请选择'}]
                                _self.cityPicker = _self.cityPicker.concat(ret.data);
                            }
                        })
                    }else{
                        _self.city_key   = 0
                        _self.cityPicker = [{id:0,name:'请选择'}];
                    }
                    _self.address_info.province = 0;
                    _self.address_info.province_name = '请选择';
                    _self.address_info.city = 0;
                    _self.address_info.city_name = '请选择';
                }else if(type === 'state'){
                    this.address_info.province_name = e.name;
                    this.address_info.province = e.id;
                    this.showStatePicker = false;
                    if(e.id > 0) {
                        url = 'api/region/index';
                        data = {pid: e.id};
                        this.POST(url, data, function (ret) {
                            if (ret.code === 0) {
                                _self.city_key   = 0
                                _self.cityPicker = [{id:0,name:'请选择'}]
                                _self.cityPicker = _self.cityPicker.concat(ret.data);
                            }
                        })
                    }else{
                        _self.city_key   = 0
                        _self.cityPicker = [{id:0,name:'请选择'}];
                    }
                    _self.address_info.city = 0;
                    _self.address_info.city_name = '请选择';
                }else if(type === 'city'){
                    this.address_info.city_name = e.name;
                    this.address_info.city = e.id;
                    this.showCityPicker = false;
                }
            },
            saveAddress(){
                // 表单验证
                if(!this.full_name) {
                    this.$toast('请输入收货人姓名');
                    return false;
                }
                if(!this.tel) {
                    this.$toast('请输入手机号');
                    return false;
                }
                if(!/^1[3-9]\d{9}$/.test(this.tel)) {
                    this.$toast('请输入正确的手机号');
                    return false;
                }
                if(this.address_info.country == 0){
                    this.$toast('请选择国家');
                    return false;
                }
                if(this.address_info.province == 0){
                    this.$toast('请选择省份');
                    return false;
                }
                if(this.address_info.city == 0){
                    this.$toast('请选择城市');
                    return false;
                }
                if(!this.address_line) {
                    this.$toast('请输入详细地址');
                    return false;
                }

                var url = 'api/useraddress/save';
                var _self = this;
                this.address_info = {
                    name: this.full_name,
                    city: this.city_id,
                    email: this.email,
                    country: this.country_id,
                    province: this.province_id,
                    postal_code: this.postal_code,
                    tel: this.tel,
                    address: this.address_line,
                };
                this.POST(url,this.address_info,function (ret) {
                    if(ret.code === 0){
                        _self.$toast('保存成功');
                        _self.$router.push('Address');
                    }else{
                        _self.$toast(ret.msg)
                    }
                })
            }
        },
    }
</script>